export default __webpack_public_path__ + "static/media/2285.0e0db9c3.png";